import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const useIsEnabledMyGroupsFeed = () => {
  const { currentNetwork } = useDefaultAppContexts();

  return !!currentNetwork?.network_configuration?.live_feed_v2
    ?.my_groups_enabled;
};

export default useIsEnabledMyGroupsFeed;
